import { render, staticRenderFns } from "./HeaderName.vue?vue&type=template&id=7d126658&scoped=true"
import script from "./HeaderName.vue?vue&type=script&lang=js"
export * from "./HeaderName.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d126658",
  null
  
)

export default component.exports